import React, { useState, useEffect, useRef } from "react";
import apiService from "../services/api.service";
import ImageGallery from "../imageGallery";
import { Link, useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { addItem, removeItem, selectCartItems } from "../Redux/shoppingCartReducer";
import i18next from "i18next";
import { Row, Col } from "react-bootstrap";
import StorageSessionService from "../services/storage.service";
import DropdownCheckbox from "../DropdownCheckbox";
import Company from "../companyComponents/Company";
import SendTo from "../SendTo";
import ProductDetailsRows from "../ProductDetailsRows";
import { eventService } from "../services/event.service";

function CompanyProductComponent() {
    const paymentStep = useSelector((state) => state.cart.payment.payload)
    const [sendToWorkers, setSendToWorkes] = useState(false)
    const [product, setProduct] = useState([]);
    const [lang, setLang] = useState("");
    const { t } = useTranslation();
    const workers = useSelector((state) => state.company.workers)
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const itemsCount = useSelector((state) => state.cart.itemCount)
    const productsFromSession = window.sessionStorage.getItem("products");
    const chainId = new URLSearchParams(location.search).get("chainid") || 0;
    const propertyId = new URLSearchParams(location.search).get("propid") || 0;
    const LastfreePriceChosenKey = 'LastfreePriceChosen';
    const sessionService = new StorageSessionService();
    const companyUser = useSelector((state) => state.company.companyUser)
    const company = useSelector((state) => state.company.company)
    let cartItems = useSelector(selectCartItems);
    cartItems = productsFromSession ? JSON.parse(productsFromSession) : cartItems;
    const [dropdownState, setDropdownState] = useState(false)
    const dropdownButtonRef = useRef(null)
    const [allWorkers, setAllWorkers] = useState([])
    const [invalidWorkersAmount, setInvalidWorkersAmount] = useState(false)
    const [productSelected, setProductSelected] = useState(false)
    const [invalidProductAmount, setInvalidProductAmount] = useState(false)

    const SetLanguage = (l) => {
        i18next.changeLanguage(l);
    };

    useEffect(() => {
        if (sessionStorage.getItem('products')) {
            let products = JSON.parse(sessionStorage.getItem('products'))
            if ((Object.keys(products)[0] === 'undefined')) {
                addItemToCart()
            }
        } else {
            addItemToCart()
        }
    }, [product])

    useEffect(() => {
        if (company) {
            apiService.getCompanyWorkers(company.companyId).then((response) => {
                setAllWorkers(response.data.data)
            })
        }
    }, [])

    useEffect(() => {
        if (!sendToWorkers) {
            setInvalidWorkersAmount(false)
        }
        if (workers && workers.length == itemsCount) {
            setInvalidWorkersAmount(false)
        }
    }, [itemsCount, workers, sendToWorkers])

    useEffect(() => {
        if (company) {
            setLang(new URLSearchParams(location.search).get("lang") || "eng");
            const selectedProductId = new URLSearchParams(location.search).get("pid") || 0;
            getProducts(selectedProductId);
            if (window.parent === window.self) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                console.info("Prod page window.parent === window.self");
            } else {
                console.info('dispatch event to scroll!');
                window.parent.postMessage({ toScroll: true }, '*');
            }
        }
    }, []);

    useEffect(() => {
        SetLanguage(lang);
    }, [lang]);

    const toggleDropdown = () => {
        dropdownState ? setDropdownState(false) : setDropdownState(true)
    }

    const closeDropdown = () => {
        setDropdownState(false)
    }

    const getProducts = (selectedProductId) => {
        apiService.getProducts(chainId, propertyId, true, selectedProductId).then(
            (response) => {

                let currentproduct = response.data.data;
                sessionService.getSessionStorage(LastfreePriceChosenKey).then(res => {
                    let lastLastfreePriceChosen = res || null;
                    if (lastLastfreePriceChosen) {
                        currentproduct[0].productPrice = parseInt(lastLastfreePriceChosen);
                    }
                    setProduct(currentproduct[0]);
                });
            },
            (error) => {
                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
            }
        );
    };

    const addItemToCart = () => {
        dispatch(addItem({ selectedProduct: product }));
        if (product.productTypeId !== window.productTypeIdGoods && !companyUser) {
            blockProduct(1);
        }
    };

    const gotoReg = () => {
        if (itemsCount > 0) {
            if (sendToWorkers) {
                if (workers && workers.length === itemsCount) {
                    blockProduct(itemsCount);
                } else {
                    setInvalidWorkersAmount(true)
                }
            } else {
                blockProduct(itemsCount);
            }
        }
    }

    const blockProduct = (amount) => {
        sessionStorage.removeItem('productBlockingIdentifier');
        apiService.blockProduct(product.productId, amount).then(
            (response) => {

                let productBlockingIdentifier = response.data;
                if (productBlockingIdentifier) {
                    sessionStorage.setItem('productBlockingIdentifier', productBlockingIdentifier);
                    sessionStorage.setItem('productBlockingIdentifierTime', new Date().toISOString());
                    history.push(`/registrastion?chainid=${chainId}&lang=${lang}`);
                    eventService.addToCart();
                }
                else {
                    alert(t("prodNotAvail"));
                }
            },
            (error) => {
                console.log(error)
                alert(t("prodNotAvail"));
            }
        );
    }

    const handleKeyPress = (e) => {
        if (e.keyCode === 13) {
            toggleDropdown()
        }
        if (e.keyCode === 27) {
            closeDropdown()
        }
    }

    const insertNewSearch = (prod) => {
        apiService.insertSearch(prod.productId, null, null, null, true, new Date().toISOString());
        sessionStorage.removeItem('lastOrderNum');
        sessionStorage.removeItem('lastCustomer');
        sessionStorage.removeItem('payerName');
    }
    const removeItemFromCart = () => {
        if (itemsCount > 1) {
            dispatch(removeItem({ productId: product.productId }))
        }
    };

    const getProductTranslations = (prod) => {
        if (prod && prod.translations) {
            let ProductTranslations = prod.translations.filter((p) => {
                return p.languageIsoCode == lang && p.propductId == prod.propductId;
            });
            return ProductTranslations.length > 0 ? ProductTranslations[0] : {};
        }
        return {};
    };

    const checkProductSelected = () => {
        if (itemsCount > 0) {
            setInvalidProductAmount(false)
            insertNewSearch(product)
            setProductSelected(true)
            eventService.viewItem(product);
        } else {
            setInvalidProductAmount(true)
        }
    }

    return (
        <>
            <div className="comp-prod-greeting hidden-desk">
                <Company />
            </div>
            <Row className="comp-prod-heading border-underline-big">
                <Col className="name" role="heading" aria-label={getProductTranslations(product).productName ? getProductTranslations(product).productName : product.productName} dangerouslySetInnerHTML={{ __html: getProductTranslations(product).productName ? getProductTranslations(product).productName : product.productName }}></Col>
                <Col className="price hidden-mobile">
                    <Link aria-label={t("backToProductsList")} className="btn white" to={`/?chainid=${chainId}&lang=${lang}`} >{t("backToProductsList")}</Link>
                </Col>
            </Row>
            <Row className="comp-product">
                <Col sm={12} md={6} className="shop-item">
                    <ImageGallery product={product || null} images={product.images || []} />
                </Col>
                <Col sm={12} md={6} >
                    <div className="descr-wrap">
                        <div className="btns-wrap">
                            <ProductDetailsRows
                                product={product}
                                itemsCount={itemsCount}
                                addItemToCart={addItemToCart}
                                removeItemFromCart={removeItemFromCart}
                                invalidProductAmount={invalidProductAmount}
                            />
                            <Row>
                                {!productSelected &&
                                    <Col sm={12} className="book-btn mt-2 d-flex justify-content-end"><button aria-label={t("Continue")} className="btn long company-btn" onClick={() => checkProductSelected()}>{t("Continue")} </button></Col>
                                }
                                {productSelected && !!companyUser && !!itemsCount && <>
                                    <h3 aria-label={t("sendVouchersTo")} className="comp-gift-to">{t("sendVouchersTo")}</h3>
                                    <div>
                                        <SendTo
                                            paymentStep={paymentStep}
                                            setSendToWorkes={setSendToWorkes}
                                        />
                                        {sendToWorkers &&
                                            <>
                                                <div ref={dropdownButtonRef} onKeyDown={e => handleKeyPress(e)} className="search-worker" onClick={e => toggleDropdown(e)}>
                                                    <i>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L5 3.58579L8.29289 0.292893C8.68342 -0.0976311 9.31658 -0.0976311 9.70711 0.292893C10.0976 0.683417 10.0976 1.31658 9.70711 1.70711L5.70711 5.70711C5.31658 6.09763 4.68342 6.09763 4.29289 5.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z" fill="#333333" />
                                                        </svg>
                                                    </i>
                                                    <input type="button" className="text-end" value={t("youChose") + " " + workers.length + " " + t("recipients")} />
                                                </div>
                                                {dropdownState &&
                                                    <DropdownCheckbox
                                                        allWorkers={allWorkers}
                                                        closeDropdown={closeDropdown}
                                                        dropdownButtonRef={dropdownButtonRef}
                                                    />
                                                }
                                                {invalidWorkersAmount &&
                                                    <span role="alert" className="text-danger bold">{t("choose")} {itemsCount} {t("recipients")}</span>
                                                }
                                            </>
                                        }
                                        <Col sm={12} className="book-btn text-start mt-4"><button aria-label={t("book")} className="btn long order-btn mb-4" onClick={e => gotoReg()}>{t("Continue")}</button></Col>
                                    </div>
                                </>
                                }
                            </Row>
                        </div>
                    </div>
                    {!productSelected &&
                        <div className="descr-wrap pt-4 w-100" dangerouslySetInnerHTML={{ __html: getProductTranslations(product)?.productDescription }}></div>
                    }
                    <Col sm={12} className="text-start mt-4 p-4 hidden-desk"><Link aria-label={t("backToProductsList")} className="btn white mobile-back-btn" to={`/?chainid=${chainId}&lang=${lang}`} >{t("backToProductsList")}</Link></Col>

                </Col>
            </Row>
        </>
    );
}

export default CompanyProductComponent;
